import { ThemeDefinition } from 'src/game/theme/Theme';
import type {
  BundleSaleThemeAssetKey,
  BundleSaleThemeAssets,
  BundleSaleThemeProvider,
  BundleSaleThemeStyleKey,
  BundleSaleThemeStyles,
} from '../match2-bundlesale.theme';

/** Base path for all bundle sale assets */
const basePath = 'assets/ui/match2/bundlesale';

/** Assets for the theme */
const assets: BundleSaleThemeAssets = {
  // Shared assets
  arrow: `${basePath}/bundlesale_arrow.png`,
  lock: `${basePath}/bundlesale_lock.png`,
  infinite: `${basePath}/bundlesale_infinite.png`,
  chest: `${basePath}/bundlesale_chest.png`,
  check: `${basePath}/bundlesale_check.png`,
  card_normal: `${basePath}/bundlesale_card_normal.png`,
  card_current: `${basePath}/bundlesale_card_current.png`,
  button_green: `${basePath}/bundlesale_button_green.png`,

  // Theme assets
  title_ja: `${basePath}/theme_newyear/newyear_title_ja.png`,
  title_en: `${basePath}/theme_newyear/newyear_title_en.png`,
  header: `${basePath}/theme_newyear/newyear_header.png`,
  snowflake: '',

  // Alternative home screen button
  button: '',
};

/** View styles for the theme */
const styles: BundleSaleThemeStyles = {
  header: {
    width: 720,
    height: 384,
  },
  title_en: {
    width: 450,
    height: 180,
    y: 120,
  },
  title_ja: {
    width: 450,
    height: 180,
    y: 145,
  },
  timer: {
    y: 240,
  },
  info: {
    y: 310,
  },
  button_image: {
    width: 144,
    height: 156,
  },
  button_timer: {
    offsetY: -3,
  },
  snowflake: {},
};

export const bundleSaleThemeNewYear: ThemeDefinition<BundleSaleThemeProvider> =
  {
    getStyle: (key: BundleSaleThemeStyleKey) => styles[key],
    getAsset: (key: BundleSaleThemeAssetKey) => assets[key],
    getAssets: () => Object.values(assets),
  };
